import { render } from "./game_features_slider.vue?vue&type=template&id=1df1b6cb"
import script from "./game_features_slider.vue?vue&type=script&lang=js"
export * from "./game_features_slider.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__